export const NAME = 'contests';

export const SUB_TABS = {
  ACTIVE: 'active',
  MY_ENTRIES: 'my-entries',
  ENDED: 'ended',
};
